import React from 'react';

const Upload = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 18" {...props}>
    <path
      fillRule="evenodd"
      d="M13 16v.998a.997.997 0 0 1-1.994 0V16H6c-3.31 0-6-2.69-6-6 0-3.09 2.34-5.64 5.35-5.96A7.496 7.496 0 0 1 12 0a7.49 7.49 0 0 1 7.35 6.04C21.95 6.22 24 8.36 24 11c0 2.76-2.24 5-5 5h-6zm0-2h6c1.66 0 3-1.34 3-3s-1.34-3-3-3h-1.5v-.5C17.5 4.46 15.04 2 12 2 9.48 2 7.37 3.69 6.71 6H6c-2.21 0-4 1.79-4 4s1.79 4 4 4h5.006V9.825l-1.831 1.832a.995.995 0 0 1-1.414 0 .999.999 0 0 1 .002-1.416l3.532-3.532a.996.996 0 0 1 1.418 0l3.53 3.532c.4.4.393 1.025.003 1.416a.998.998 0 0 1-1.414 0L13 9.825V14zm-1.994 0H9v2h2.006v-2zM13 14v2h2v-2h-2z"
    />
  </svg>
);

export default Upload;
